<dx-data-grid
  [dataSource]="produitComplementaireList()"
  [keyExpr]="keyExpr()"
  [showBorders]="true"
  [showRowLines]="true"
  [wordWrapEnabled]="true"
  [rowAlternationEnabled]="true"
  [columnAutoWidth]="false"
  [allowColumnResizing]="true"
  columnResizingMode="widget"
  (onCellPrepared)="onCellPrepared($event)"
  (onCellClick)="onCellClick($event)"
  (onRowUpdated)="ligneEditee.emit()"
  width="100%"
  height="100%"
  [noDataText]="noDataText()">

  <dxo-editing mode="cell" [allowUpdating]="editable()"></dxo-editing>

  <dxo-sorting mode="single" showSortIndexes="false"></dxo-sorting>

  <dxo-header-filter [visible]="true" [allowSearch]="false"></dxo-header-filter>

  <dxo-paging [enabled]="pagingInterne()" [pageSize]="PAGE_SIZE"></dxo-paging>

  <dxo-pager
    [visible]="pagingInterne()"
    [showInfo]="true"
    [showNavigationButtons]="true"
    [showPageSizeSelector]="false"
    infoText="Page {0} sur {1} ({2} produits)">
  </dxo-pager>

  <dxi-column
    dataField="produitDeclinaisonId"
    caption="Actions"
    [width]="100"
    [allowEditing]="false"
    [allowSorting]="false"
    [allowResizing]="false"
    [allowHeaderFiltering]="false"
    cellTemplate="actionsCellTemplate">
  </dxi-column>

  <dxi-column
    name="produit"
    caption="Produit décliné"
    [minWidth]="200"
    [allowEditing]="false"
    [allowSorting]="true"
    [allowHeaderFiltering]="false"
    sortOrder="asc"
    [calculateCellValue]="paramSvc.getProduitLibelle"
    cellTemplate="produitCellTemplate">
  </dxi-column>

  <dxi-column
    name="plc"
    caption="Point de livraison"
    [minWidth]="180"
    [visible]="plcColonneVisible()"
    [allowEditing]="false"
    [allowSorting]="true"
    [allowHeaderFiltering]="false"
    [calculateCellValue]="paramSvc.getPlcLibelle"
    cellTemplate="plcCellTemplate">
  </dxi-column>

  <dxi-column
    dataField="facturable"
    caption="Facturable"
    dataType="boolean"
    [width]="120"
    [allowSorting]="false"
    [allowHeaderFiltering]="true"
    trueText="Oui"
    falseText="Non"
    cssClass="produit-complementaire-cell-centre">
  </dxi-column>

  <dxi-column
    dataField="commandablePortail"
    caption="Commandable portail"
    dataType="boolean"
    [width]="160"
    [allowSorting]="false"
    [allowHeaderFiltering]="true"
    trueText="Oui"
    falseText="Non"
    cssClass="produit-complementaire-cell-centre">
  </dxi-column>

  <dxi-column caption="Jours de consommation">
    @for (jourColonne of paramSvc.jourColonneList; track jourColonne.name) {
      <dxi-column
        [name]="jourColonne.name"
        [caption]="jourColonne.caption"
        dataType="boolean"
        [width]="80"
        [allowEditing]="false"
        [allowSorting]="false"
        [allowHeaderFiltering]="true"
        trueText="Oui"
        falseText="Non"
        [calculateCellValue]="jourColonne.calculateCellValue"
        cssClass="produit-complementaire-cell-centre"
        cellTemplate="jourCellTemplate">
      </dxi-column>
    }
  </dxi-column>

  <dxi-column caption="Périodes de conditionnement">
    <dxi-column
      [name]="paramSvc.COLONNE_PERIODE_DATE"
      caption="Date"
      [width]="100"
      [allowEditing]="false"
      [allowSorting]="false"
      [allowHeaderFiltering]="false"
      cssClass="produit-complementaire-cell-periode"
      cellTemplate="periodeDateCellTemplate">
    </dxi-column>
    <dxi-column
      [name]="paramSvc.COLONNE_PERIODE_UNITE"
      caption="Unité commandable"
      [width]="200"
      [allowEditing]="false"
      [allowSorting]="false"
      [allowHeaderFiltering]="false"
      cssClass="produit-complementaire-cell-periode"
      cellTemplate="periodeUniteCellTemplate">
    </dxi-column>
    <dxi-column
      [name]="paramSvc.COLONNE_PERIODE_RATIO"
      caption="Ratio"
      [width]="80"
      [allowEditing]="false"
      [allowSorting]="false"
      [allowHeaderFiltering]="false"
      cssClass="produit-complementaire-cell-periode"
      cellTemplate="periodeRatioCellTemplate">
    </dxi-column>
    <dxi-column
      [name]="paramSvc.COLONNE_PERIODE_UNITE_TECHNIQUE"
      caption="UT"
      [width]="80"
      [allowEditing]="false"
      [allowSorting]="false"
      [allowHeaderFiltering]="false"
      cssClass="produit-complementaire-cell-periode"
      cellTemplate="periodeUniteTechniqueCellTemplate">
    </dxi-column>
  </dxi-column>

  <div *dxTemplate="let cell of 'produitCellTemplate'" class="produit-complementaire-cell-content" [title]="paramSvc.getNatureLibelle(cell.data)">
    <yo-icon [icon]="paramSvc.getNatureIcon(cell.data)" [theme]="paramSvc.getNatureTheme(cell.data)" cssClass="mg-r-5"></yo-icon>
    <span class="produit-complementaire-libelle">{{ paramSvc.getProduitLibelle(cell.data) }}</span>
  </div>

  <div *dxTemplate="let cell of 'plcCellTemplate'" class="produit-complementaire-cell-content" [title]="paramSvc.getPlcTooltip(cell.data)">
    <span class="produit-complementaire-libelle">{{ paramSvc.getPlcLibelle(cell.data) }}</span>
  </div>

  <div *dxTemplate="let cell of 'periodeDateCellTemplate'" class="produit-complementaire-periode-cell">
    @for (periode of paramSvc.getPeriodeList(cell.data); track periode.dateDebut) {
      <span>{{ periode.dateDebut | date: 'dd/MM/yyyy' }}</span>
    }
  </div>

  <div *dxTemplate="let cell of 'periodeUniteCellTemplate'" class="produit-complementaire-periode-cell">
    @for (periode of paramSvc.getPeriodeList(cell.data); track periode.dateDebut) {
      <span>{{ paramSvc.getPeriodeUniteLibelle(cell.data, periode) }}</span>
    }
  </div>

  <div *dxTemplate="let cell of 'periodeRatioCellTemplate'" class="produit-complementaire-periode-cell">
    @for (periode of paramSvc.getPeriodeList(cell.data); track periode.dateDebut) {
      <span>{{ paramSvc.getPeriodeRatio(periode) }}</span>
    }
  </div>

  <div *dxTemplate="let cell of 'periodeUniteTechniqueCellTemplate'" class="produit-complementaire-periode-cell">
    @for (periode of paramSvc.getPeriodeList(cell.data); track periode.dateDebut) {
      <span>{{ paramSvc.getUniteTechniqueAbreviation(cell.data) }}</span>
    }
  </div>

  <div *dxTemplate="let cell of 'jourCellTemplate'" class="produit-complementaire-jour-content" [title]="paramSvc.getJourLibelle(cell.column.name)">
    @if (cell.value) {
      <yo-icon icon="check" [theme]="IconThemeEnum.SUCCESS_INNER"></yo-icon>
    }
  </div>

  <div *dxTemplate="let cell of 'actionsCellTemplate'" class="custom-button-container">
    <yo-button
      size="small"
      iconClass="fas fa-calendar"
      [theme]="ButtonThemeEnum.DEFAULT_INNER"
      tooltip="Périodes de conditionnement"
      [disabled]="!editable()"
      (onClick)="periodeClick.emit(cell.row.data)">
    </yo-button>
    <yo-button
      size="small"
      [iconClass]="suppressionIconClass()"
      [theme]="ButtonThemeEnum.DELETE_INNER"
      [tooltip]="suppressionTooltip()"
      [disabled]="!editable()"
      (onClick)="suppressionClick.emit(cell.row.data)">
    </yo-button>
  </div>
</dx-data-grid>
